<template>
  <div class="uyh-mantra-format">
    <div class="format-header">
      <div class="uyh-back">
        <router-link to="/">
          <svg svg-inline="" class="uyh-back-arrow js-back" role="presentation" focusable="false" width="19" height="30" viewBox="0 0 19 30" xmlns="http://www.w3.org/2000/svg"><path d="M15.882 30L0 15 15.882 0l3.065 2.896L6.131 15l12.816 12.103z" fill="#21362C" fill-rule="evenodd"/></svg><span>{{ $t('navigation.back') }}</span>
        </router-link>
      </div>

      <StepInfo :step="'1'" :totalSteps="'3'" :message="$t('step_nav.choose_template')"/>
    </div>

    <div class="format-selector text" :class="{obscured: overlay_left_active}">
      <div class="overlay"></div>
      <p>{{ $t('pick_mantra.text_only') }}</p>

      <div class="uyh-background primary" :style="[getBackground(textMantra.presets.primarybackground)]" :class="[tempId(textMantra.id)]">
        <div class="uyh-background secondary" :style="[getBackground(textMantra.presets.secondarybackground)]"></div>
        <div class="uyh-background textarea" :style="[getBackground(textMantra.presets.textareacolor)]" :class="[{border: hasBorder(textMantra.presets.textareaborder)}]">
          <p v-if="textMantra.hashtag"  class="uyh-hashtag" :style="{color: textMantra.presets.textcolor}">{{ $t('mantras.hashtags.' + textMantra.hashtag) }}</p>
          <h1 :class="textMantra.presets.textweight" :style="{color: textMantra.presets.textcolor}" v-html="$t('mantras.messages.text.' + textMantra.message)"></h1>
          <svg v-if="textMantra.icon == 'true'" svg-inline="" :style="{fill: textMantra.presets.textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
        </div>
      </div>

      <div class="next">
        <router-link to="/pick-a-mantra/text"
                     @mouseover.native="overlay_right_active = true"
                     @mouseleave.native="overlay_right_active = false">
          {{ $t('navigation.next') }}
        </router-link>
      </div>

    </div>


    <div class="format-selector photo"  :class="{obscured: overlay_right_active}">
      <div class="overlay"></div>
      <p>{{ $t('pick_mantra.image') }}</p>

      <div class="uyh-background primary" :style="[getBackground(imageMantra.presets.primarybackground)]" :class="[tempId(imageMantra.id)]">
        <div class="uyh-background image" :style="{backgroundImage: `url('${featureImage}')`}"></div>
        <div v-if="imageMantra.presets.secondarybackground" class="uyh-background secondary" :style="[getBackground(imageMantra.presets.secondarybackground)]"></div>
        <div class="uyh-background textarea" :style="[getBackground(imageMantra.presets.textareacolor)]" :class="[{border: hasBorder(imageMantra.presets.textareaborder)}]">
          <p v-if="imageMantra.hashtag" class="uyh-hashtag" :style="{color: imageMantra.presets.textcolor}">{{ $t('mantras.hashtags.' + imageMantra.hashtag) }}</p>
          <h1 :class="imageMantra.presets.textweight" :style="{color: imageMantra.presets.textcolor}" v-html="$t('mantras.messages.image.' + imageMantra.message)"></h1>
          <svg v-if="imageMantra.icon == 'true'" svg-inline="" :style="{fill: imageMantra.presets.textcolor}" role="presentation" focusable="false" width="34" height="32" viewBox="0 0 34 32" xmlns="http://www.w3.org/2000/svg"><path d="M12.32 24.995v-.34c0-.766.242-1.467 1.11-3.114l2.147-4.065-.526-.255c-.854 1.248-2.248 3.552-5.176 3.55C7.002 20.769 5 18.51 5 15.523c.002-2.844 2.023-5.031 4.653-7.205l7.194-5.983h.285l7.191 5.988c2.63 2.176 4.675 4.34 4.674 7.182-.002 2.984-2.032 5.273-4.905 5.273-2.93-.002-4.325-2.306-5.177-3.556l-.523.254 2.145 4.068c.865 1.647 1.107 2.349 1.107 3.115V25l-9.324-.005" fill-rule="evenodd"/></svg>
        </div>
      </div>

      <div class="next">
        <router-link to="/pick-a-mantra/image"
                     @mouseover.native="overlay_left_active = true"
                     @mouseleave.native="overlay_left_active = false">
          {{ $t('navigation.next') }}
        </router-link>
      </div>

    </div>
  </div>
</template>


<script>
  import StepInfo from '@/components/Global_StepInfo.vue'
  import TextMantras from '@/assets/text_mantras.json'
  import ImageMantras from '@/assets/image_mantras.json'

  const rootHost = process.env.BASE_URL;

  export default {
    components: {
      StepInfo
    },
    data: function() {
      return {
        overlay_left_active: false,
        overlay_right_active: false
      }
    },
    methods: {
      tempId: function(mantraId) {
        return 'temp-' + mantraId.toString();
      },
      getBackground: function(backgroundData) {
        if (backgroundData.includes('patterns')) {
          if (backgroundData.includes('_Swatch')) {
            backgroundData = backgroundData.replace('_Swatch', '_640X640');
          }
          return { backgroundImage: 'url(' + rootHost + backgroundData + ')' }
        } else {
          return { background: backgroundData }
        }
      },
      hasBorder: function(borderValue) {
        var border = false;
        if (borderValue == 'border') {
          border = true;
        }
        return border;
      }
    },
    computed: {
      textMantra: function() {
        return TextMantras.mantras[0];
      },
      imageMantra: function() {
        return ImageMantras.mantras[0];
      },
      featureImage: function() {
        return rootHost + 'img/placeholder.jpg';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .responsivesite #wrapper #uyh-app,
  #uyh-app {
    $mobile-breakpoint: 767px;
    $tablet-portrait-down-breakpoint: 1023px;
    $tablet-portrait-breakpoint: 1024px;
    $tablet-down-breakpoint: 1199px;
    $hd-desktop-breakpoint: 1280px;
    .uyh-mantra-format {
      display: flex;
      flex-wrap: nowrap;
      position: relative;
      .format-header {
        left: 0;
        position: absolute;
        top: 0;
        width: 100%;
        z-index: 2;
      }
      .format-selector {
        align-content: center;
        display: flex;
        flex: 1 0 50%;
        flex-wrap: wrap;
        justify-content: space-between;
        padding: 119px 0;
        @media screen and (min-width: $tablet-portrait-breakpoint) and (max-width: $hd-desktop-breakpoint){
          padding: 75px 0;
        }

        > p {
          flex: 1 0 100%;
          font-size: 23px;
        }
        .next {
          flex: 1 0 100%;
          padding-top: 38px;
          a {
            display: inline-block;
            font-size: 20px;
            letter-spacing: 1px;
          }
        }

        &.text {
          background-color: #e0e9e7;
        }
        &.photo {
          background-color: #fceff3;
        }

        &.text,
        &.photo {
          position: relative;
          .uyh-background {
            &.primary {
              flex: 0 0 100%;
              margin-top: 23px;
              max-width: 600px;
              width: calc(50vw - 6.7rem);
              @media screen and (min-width: $tablet-portrait-breakpoint) and (max-width: $hd-desktop-breakpoint){
                flex: 0 1 auto;
                max-width: calc(50vw - 100px);
                min-width: initial;
                width: calc(100vh - 277px);
              }
            }
          }
          .overlay {
            background-color: rgba(0,0,0,0);
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            transition: background-color 0.3s ease-in-out;
            width: 100%;
            z-index: -1;
          }

          &.obscured {
            .overlay {
              background-color: rgba(0,0,0,0.7);
              z-index: 1;
            }
          }
        }

        &.text {
          .uyh-background {
            &.primary {
              h1 {
                margin: 0;
              }
              &.temp-1 {
                h1 {
                  font-size: 90px;
                }

                .uyh-hashtag,
                svg {
                  left: 50%;
                  position: absolute;
                  transform: translateX(-50%);
                }
                .uyh-hashtag {
                  top: 10%;
                }
                svg {
                  bottom: 10%;
                }

                @media screen and (max-width: $hd-desktop-breakpoint) {
                  h1 {
                    font-size: calc(90px * 375 / 640);
                  }
                }
                @media screen and (min-width: $tablet-portrait-breakpoint) and (max-width: $hd-desktop-breakpoint){
                  font-size: calc(90px * 325 / 640);
                }
                @media screen and (max-width: $mobile-breakpoint) {
                  h1 {
                    font-size: 60px;
                  }
                }
              }
            }
          }
        }

        &.photo {
          max-width: 100%;
          .uyh-background {
            &.primary {
              &.temp-1 {
                .image {
                  background-position: 50% 50%;
                  background-size: cover;
                  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
                  left: 50%;
                  height: calc(51 / 64 * 100%);
                  overflow: hidden;
                  position: absolute;
                  top: 30px;
                  transform: translateX(-50%);
                  width: calc(17 / 32 * 100%);
                  @media screen and (max-width: $tablet-portrait-down-breakpoint) {
                    top: 25px;
                  }
                }

                .textarea,
                .secondary {
                  bottom: 30px;
                  height: 200px;
                  top: initial;
                  transform: translateX(-50%);
                  width: 200px;
                  @media screen and (max-width: $hd-desktop-breakpoint){
                    bottom: 10px;
                    height: 130px;
                    width: 130px;
                  }
                }

                .textarea {
                  padding: 16px 0 6px;
                  @media screen and (max-width: $hd-desktop-breakpoint){
                    padding: 10px 0 0;
                  }

                  h1 {
                    font-size: 27px;
                    margin: 0;
                    @media screen and (max-width: $hd-desktop-breakpoint){
                      font-size: 18px;
                      line-height: 1.25;
                    }
                  }

                  .uyh-hashtag {
                    @media screen and (max-width: $hd-desktop-breakpoint){
                      font-size: 11px;
                    }
                  }

                  svg {
                    height: 22px;
                    @media screen and (max-width: $hd-desktop-breakpoint){
                      height: 13.5px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    @media screen and (max-width: $tablet-down-breakpoint) {
      .mantra-format {
        .uyh-mantra-format {
          .format-header {
            .uyh-back {
              top: -31px;
            }
          }
        }
      }
    }
    @media screen and (max-width: $mobile-breakpoint) {
      .mantra-format {
        .uyh-mantra-format {
          .format-selector {
            min-height: 595px;
            padding: 119px 12px;
            &.text,
            &.photo {
              .uyh-background {
                &.primary {
                  min-width: initial;
                  width: calc(50vw - 48px);
                }
              }
            }

            &.text {
              .uyh-background {
                &.primary {
                  &.temp-1 {
                    .uyh-hashtag {
                      top: 10%;
                      font-size: 10px;
                    }
                    h1 {
                      font-size: 24px;
                    }
                    svg {
                      bottom: 10%;
                      height: 15px;
                      width: 15px;
                    }
                  }
                }
              }
            }

            &.photo {
              .uyh-background {
                &.primary {
                  &.temp-1 {
                    .image {
                      top: 12px;
                      height: 85%;
                      width: 56%;
                    }
                    .textarea {
                      height: 70px;
                      padding: 0;
                      width: 70px;
                      .uyh-hashtag {
                        top: 10%;
                        font-size: 6px;
                      }
                      h1 {
                        font-size: 10px;
                        line-height: 1;
                      }
                      svg {
                        bottom: 0%;
                        height: 8px;
                        width: 8px;
                      }
                    }
                  }
                }
              }
            }

          }
        }
      }
    }
  }
</style>
